import Header from '../Header'
import Hero from '../Hero';
import AboutWinax from '../AboutWinax';
import Niche from '../Niche';
import Loans from '../Loans';
import Funding from '../Funding.jsx';
import Projects from '../Projects';
import Testimonial from '../Testimonial';
import News from '../News';
import Carousel from '../Carousel';
import Footer from '../Footer';
import { useEffect } from 'react';


const Home = (props)=> {

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
      
    return(
        <>
            <Header />
            <Hero />
            <AboutWinax />
            <Niche />
            <Funding />
            {/* <Projects /> */}
            <Testimonial/>
            <Carousel/>
            <News/>
            <Footer/>
        </>
    )
}



export default Home